import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

export const DefaultRedirection = () => {
    const token = localStorage.getItem("astroVani-admin-token");
    const [form, setForm] = useState({
        android: {
            notRegistered: "Home",
            registered: "Connect",
            registeredButNotAvailedFreeChat: "Home",
            paid: "Wallet page",
            afterRecharge: "Home"
        },
        ios: {
            notRegistered: "Home",
            registered: "Connect",
            registeredButNotAvailedFreeChat: "Home",
            paid: "Wallet page",
            afterRecharge: "Home"
        }
    });

    const [loading, setLoading] = useState(false);
    const [platform, setPlatform] = useState("android");
    const [skipPlatform, setSkipPlatform] = useState("android");
    const [skipForm, setSkipForm] = useState({
        android: {
            showSkipButton: true,
            skipRedirection: "Home"
        },
        ios: {
            showSkipButton: false,
            skipRedirection: "Connect"
        }
    });
    const [isHumanFreeChatEnabled, setIsHumanFreeChatEnabled] = useState(false);

    const fetchHumanFreeChatStatus = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/config/isHumanFreeChatEnabled`, {
                headers: {
                    Authorization: `${token}`,
                }
            });
            if (!response.ok) throw new Error("Failed to fetch Human Free Chat Status");
            const res = await response.json();
            if (res?.success) {
                setIsHumanFreeChatEnabled(res.data?.value === true || res.data?.value === "true");
            }
        } catch (error) {
            console.error(error);
        }
    };


    const fetchConfig = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/defaultRedirection`, {
                headers: {
                    Authorization: `${token}`,
                }
            });
            if (!response.ok) throw new Error("Failed to fetch data");
            const data = await response.json();

            if (data?.data?.value) {
                const configValue = data.data.value;
                setForm({
                    android: {
                        notRegistered: configValue.android?.notRegistered || "Home",
                        registered: configValue.android?.registered || "Connect",
                        registeredButNotAvailedFreeChat: configValue.android?.registeredButNotAvailedFreeChat || "Home",
                        paid: configValue.android?.paid || "Wallet page",
                        afterRecharge: configValue.android?.afterRecharge || "Home"
                    },
                    ios: {
                        notRegistered: configValue.ios?.notRegistered || "Home",
                        registered: configValue.ios?.registered || "Connect",
                        registeredButNotAvailedFreeChat: configValue.ios?.registeredButNotAvailedFreeChat || "Home",
                        paid: configValue.ios?.paid || "Wallet page",
                        afterRecharge: configValue.ios?.afterRecharge || "Home"
                    }
                });
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch Default Redirection settings");
        } finally {
            setLoading(false);
        }
    };

    const fetchSkipConfig = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/skipRedirection`, {
                headers: {
                    Authorization: `${token}`,
                }
            });
            if (!response.ok) throw new Error("Failed to fetch skip redirection data");
            const data = await response.json();
            if (data?.data?.value) {
                const cfg = data.data.value;
                setSkipForm({
                    android: {
                        showSkipButton: cfg.android?.showSkipButton ?? true,
                        skipRedirection: cfg.android?.skipRedirection || "Home"
                    },
                    ios: {
                        showSkipButton: cfg.ios?.showSkipButton ?? false,
                        skipRedirection: cfg.ios?.skipRedirection || "Connect"
                    }
                });
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch Skip Redirection settings");
        }
    };

    useEffect(() => {
        fetchConfig();
        fetchSkipConfig();
        fetchHumanFreeChatStatus();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [platform]: {
                ...prev[platform],
                [name]: value
            }
        }));
    };

    const handleSkipChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        setSkipForm((prev) => ({
            ...prev,
            [skipPlatform]: {
                ...prev[skipPlatform],
                [name]: val
            }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const payload = form;

            const res = await fetch(`${process.env.REACT_APP_BASEURL}/admin/defaultRedirection`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`
                },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (!res.ok || data.success === false) {
                throw new Error(data.message || "Failed to update");
            }

            toast.success("Default Redirection saved successfully!");
        } catch (err) {
            console.error(err);
            toast.error(err.message || "Error saving data");
        } finally {
            setLoading(false);
        }
    };

    const handleSkipSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const payload = skipForm;
            const res = await fetch(`${process.env.REACT_APP_BASEURL}/admin/skipRedirection`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${token}`
                },
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (!res.ok || data.success === false) {
                throw new Error(data.message || "Failed to update skip redirection");
            }
            toast.success("Skip Redirection saved successfully!");
        } catch (err) {
            console.error(err);
            toast.error(err.message || "Error saving skip redirection");
        } finally {
            setLoading(false);
        }
    };

    const handleRefresh = () => {
        fetchConfig();
        fetchSkipConfig();
        fetchHumanFreeChatStatus();
    };

    return (
        <div className="card-body modern-card p-3">
            <div className="d-flex justify-content-between align-items-center modern-header mb-3">
                <h5 className="fw-bold mb-0">Default Redirection Configuration</h5>
                <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    style={{ height: "30px" }}
                    onClick={handleRefresh}
                >
                    Refresh
                </button>
            </div>

            <form onSubmit={handleSubmit} className="modern-form">
                <div className="row g-2 small">
                    <div className="d-flex gap-2 mt-3">
                        <button
                            type="button"
                            className={`btn btn-sm ${platform === "android" ? "btn-primary" : "btn-outline-secondary"}`}
                            onClick={() => setPlatform("android")}
                        >
                            Android
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm ${platform === "ios" ? "btn-primary" : "btn-outline-secondary"}`}
                            onClick={() => setPlatform("ios")}
                        >
                            iOS
                        </button>
                    </div>

                    <div className="row g-3 small mt-2 border rounded p-3 bg-light">
                        <h6 className="fw-bold mb-2">{platform === "android" ? "Android" : "iOS"} Configuration</h6>

                        <div className="col-md-12">
                            <label>New Registered</label>
                            <select
                                className="form-control form-control-sm"
                                name="notRegistered"
                                value={form[platform].notRegistered}
                                onChange={handleChange}
                            >
                                <option value="Home">Home</option>
                                <option value="Connect">Connect</option>
                                <option value="Services">Services</option>
                                <option value="Wallet page">Wallet</option>
                                <option value={isHumanFreeChatEnabled ? "free-chat-astrologers" : "free-ai-chat"}>
                                    {isHumanFreeChatEnabled ? "free-chat-astrologers" : "free-ai-chat"}
                                </option>
                            </select>
                        </div>

                        <div className="col-md-12 mt-2">
                            <label>Registered but availed free chat</label>
                            <select
                                className="form-control form-control-sm"
                                name="registered"
                                value={form[platform].registered}
                                onChange={handleChange}
                            >
                                <option value="Home">Home</option>
                                <option value="Connect">Connect</option>
                                <option value="Services">Services</option>
                                <option value="Wallet page">Wallet</option>
                            </select>
                        </div>

                        <div className="col-md-12 mt-2">
                            <label>Registered but not availed free chat</label>
                            <select
                                className="form-control form-control-sm"
                                name="registeredButNotAvailedFreeChat"
                                value={form[platform].registeredButNotAvailedFreeChat}
                                onChange={handleChange}
                            >
                                <option value="Home">Home</option>
                                <option value="Connect">Connect</option>
                                <option value="Services">Services</option>
                                <option value="Wallet page">Wallet</option>
                                <option value={isHumanFreeChatEnabled ? "free-chat-astrologers" : "free-ai-chat"}>
                                    {isHumanFreeChatEnabled ? "free-chat-astrologers" : "free-ai-chat"}
                                </option>
                            </select>
                        </div>

                        <div className="col-md-12 mt-2">
                            <label>Paid</label>
                            <select
                                className="form-control form-control-sm"
                                name="paid"
                                value={form[platform].paid}
                                onChange={handleChange}
                            >
                                <option value="Home">Home</option>
                                <option value="Connect">Connect</option>
                                <option value="Services">Services</option>
                                <option value="Wallet page">Wallet</option>
                            </select>
                        </div>

                        <div className="col-md-12 mt-2">
                            <label>After Recharge Redirection</label>
                            <select
                                className="form-control form-control-sm"
                                name="afterRecharge"
                                value={form[platform].afterRecharge}
                                onChange={handleChange}
                            >
                                <option value="Home">Home</option>
                                <option value="Connect">Connect</option>
                                <option value="Services">Services</option>
                                <option value="Wallet page">Wallet</option>
                                <option value="Pooja Listing">Pooja Listing</option>
                            </select>
                        </div>

                        <div className="col-12 d-flex justify-content-end mt-3">
                            <button
                                type="submit"
                                className="btn btn-primary btn-sm px-4 modern-save"
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Save"}
                            </button>
                        </div>
                    </div>
                </div>
            </form>

            <hr className="my-4 text-muted" />

            {/* Skip Redirection Configuration */}
            <form onSubmit={handleSkipSubmit} className="modern-form">
                <div className="row g-2 small">
                    <div className="d-flex gap-2 mt-3">
                        <button
                            type="button"
                            className={`btn btn-sm ${skipPlatform === "android" ? "btn-primary" : "btn-outline-secondary"}`}
                            onClick={() => setSkipPlatform("android")}
                        >
                            Android
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm ${skipPlatform === "ios" ? "btn-primary" : "btn-outline-secondary"}`}
                            onClick={() => setSkipPlatform("ios")}
                        >
                            iOS
                        </button>
                    </div>
                    <div className="row g-3 small mt-2 border rounded p-3 bg-light">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold mb-0">{skipPlatform === "android" ? "Android" : "iOS"} Skip Configuration</h6>
                            <div className="form-check form-switch d-flex align-items-center gap-3 ps-0 mb-0">
                                <label className="form-check-label mb-0" htmlFor={`showSkipButtonSwitch-${skipPlatform}`} style={{ cursor: "pointer" }}>
                                    Show Skip Button
                                </label>
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0"
                                    name="showSkipButton"
                                    role="switch"
                                    id={`showSkipButtonSwitch-${skipPlatform}`}
                                    checked={skipForm[skipPlatform].showSkipButton}
                                    onChange={handleSkipChange}
                                    style={{ cursor: "pointer", width: "40px", height: "20px" }}
                                />
                            </div>
                        </div>
                        <div className="col-md-12 mt-2">
                            <label>Skip Redirection</label>
                            <select
                                className="form-control form-control-sm"
                                name="skipRedirection"
                                value={skipForm[skipPlatform].skipRedirection}
                                onChange={handleSkipChange}
                            >
                                <option value="Home">Home</option>
                                <option value="Connect">Connect</option>
                                <option value="Services">Services</option>
                                {/* <option value="Wallet page">Wallet</option> */}
                            </select>
                        </div>
                        <div className="col-12 d-flex justify-content-end mt-3">
                            <button
                                type="submit"
                                className="btn btn-primary btn-sm px-4 modern-save"
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Save Skip"}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default DefaultRedirection;
